import { Component, OnInit } from '@angular/core';
import { MyApplicationsService } from './my-app-service.service';
import { MatDialog } from '@angular/material/dialog';
import { ApplicationTypeDialogComponent } from '../application-type-dialog/application-type-dialog.component';

@Component({
  standalone: false,
  selector: 'app-my-application',
  templateUrl: './my-application.component.html',
  styleUrls: ['./my-application.component.scss']
})
export class MyApplicationsComponent {
  // Placeholder for future logic
  applications: any[] = [];

  constructor(private appService: MyApplicationsService, private dialog: MatDialog) {}
  openApplicationTypeDialog() {
    this.dialog.open(ApplicationTypeDialogComponent, {
      panelClass: 'custom-dialog-panel'
    }).afterClosed().subscribe(result => {
      if (result) {
        // Handle selected application type here
        // e.g., start a new application with the selected type
      }
    });
  }

   ngOnInit() {
    this.appService.getAllApplications().subscribe(data => {
      this.applications = data;
    });
  }
}
